export interface IContactModuleColumn {
	readonly columnId: string;
	readonly moduleId: string;
}

export class ContactModuleColumn implements IContactModuleColumn {
	private _columnId: string;
	private _moduleId: string;

	constructor(columnId: string, moduleId: string) {
		this._columnId = columnId;
		this._moduleId = moduleId;
	}

	public get columnId(): string {
		return this._columnId;
	}

	public get moduleId(): string {
		return this._moduleId;
	}
}
